export function suitEqual(suit1, suit2) {
    if (!suit1 || !suit2) {
        return false;
    }
    return suit1.suitName == suit2.suitName;
}
export function cardEqual(card1, card2) {
    return (suitEqual(card1.suit, card2.suit) && card1.cardValue === card2.cardValue);
}
const MAX_CARD_REF = 500;
export const isCardRef = (value) => {
    return typeof value === 'number' && value >= 0 && value <= MAX_CARD_REF;
};
// type NonNegativeInteger<T extends number> =
//     number extends T
//         ? never
//         : `${T}` extends `-${string}` | `${string}.${string}`
//             ? never
//             : T;
/**
 * [mutates deck by removing and returning top card]
 * @param  {Card[]} card [group of cards]
 */
export function takeTopCardRef(cards) {
    const card = cards.shift();
    if (!isCardRef(card)) {
        throw new Error('tried to get card from empty deck');
    }
    return card;
}
export function getTrumpSuit(deck) {
    return deck.suits.find((suit) => suit.suitName === deck.trumpSuitName);
}
//# sourceMappingURL=Deck.js.map